import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ApiKeysService } from './api/apiKeys.service';
import { AuthenticationService } from './api/authentication.service';
import { DkimService } from './api/dkim.service';
import { DomainsService } from './api/domains.service';
import { EmailAccountsService } from './api/emailAccounts.service';
import { FiltersService } from './api/filters.service';
import { ForwardersService } from './api/forwarders.service';
import { PackagesService } from './api/packages.service';
import { ProfileService } from './api/profile.service';
import { UsersService } from './api/users.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
